export function formatPhoneNumber(value?: string | number): string {
  if (!value) return '';
  const cleaned = String(value).replace(/\D/g, '');
  const digits = cleaned.slice(-11);
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return value.toString();
}

export function formatDDI(value?: string | number): number {
  if (!value) return 0;
  const cleaned = String(value).replace(/\D/g, '');
  if (cleaned?.startsWith('55')) return 0;
  return 1;
}

export function capitalize(word: string) {
  if (!word) return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function capitalizeWords(phrase: string) {
  return phrase
    .toLowerCase()
    .replace(/(^|\s|\.)\S/g, (match) => match.toUpperCase());
}

export const pixTypes = [
  { label: 'CPF/CNPJ', value: 1 },
  { label: 'E-mail', value: 2 },
  { label: 'Telefone', value: 3 },
  { label: 'Aleatória', value: 4 },
];

export const getFirstAndSecondName = (label: string) => {
  if (!label) return '';
  const names = label.trim().split(' ');
  if (names.length === 1) return names[0];
  return `${names[0]} ${names[1]}`;
};

export const getInitials = (label: string): string => {
  if (!label) return '';
  const parts = label.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0][0]?.toUpperCase() ?? '';
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const obfuscateCPF = (cpf: string): string => {
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) return cpf;
  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`;
};
